import styled from 'styled-components';

const NavbarContainerStyled = styled.div`
  border-top: 1px solid transparent;
  border-image: linear-gradient(to right, #4e018d, #7212e8, #c348ea);
  border-image-slice: 1;
  display: flex;
  width: 100%;
  background: #fff;
  align-items: flex-end;
  align-self: stretch;
  position: sticky;
  bottom: 0;
  z-index: 10000;
  display: flex;
  height: 75px;
  justify-content: flex-end;
`;

const NavbarItem = styled.div`
  display: flex;
  ${({ isOne }) =>
    isOne
      ? 'padding: 16px;   align-items: flex-end;'
      : 'padding: 16px 0px;   align-items: center;'}

  flex-direction: column;
  gap: 4px;
  flex: 1 0 0;

  img {
    width: 24px;
    height: 24px;
  }

  p {
    color: #494c66;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
  }

  ${({ current }) =>
    current &&
    `
    img {
      filter: invert(23%) sepia(55%) saturate(4750%) hue-rotate(267deg)
        brightness(54%) contrast(135%);
    }
  
    p {
      color: #4d008c;
      font-weight: 500;
    }
  `}
`;

export { NavbarContainerStyled, NavbarItem };
